import { defineMessages } from 'react-intl';

export const AddressValidationStatusMessages = defineMessages({
  verified: {
    description: 'filterOptions.validated',
    defaultMessage: 'Validated',
    id: 'JqWU3F',
  },
  warning: {
    description: 'filterOptions.warning',
    defaultMessage: 'Warning',
    id: 'LztrUT',
  },
  error: {
    description: 'filterOptions.error',
    defaultMessage: 'Error',
    id: 'CLSwle',
  },
  unverified: {
    description: 'filterOptions.unverified',
    defaultMessage: 'Unverified',
    id: '3dKfj3',
  },
});

export const AllocationStatusMessages = defineMessages({
  allocated: {
    description: 'filterOptions.allocated',
    defaultMessage: 'Allocated',
    id: 'rlVkKF',
  },
  unallocated: {
    description: 'filterOptions.unallocated',
    defaultMessage: 'Unallocated',
    id: 'sqeP5r',
  },
});

export const DestinationMessages = defineMessages({
  domestic: {
    description: 'filterOptions.destinationDomestic',
    defaultMessage: 'Domestic',
    id: 'y9VJCS',
  },
  international: {
    description: 'filterOptions.destinationInternational',
    defaultMessage: 'International',
    id: '94roj/',
  },
});

export const GiftMessages = defineMessages({
  isGift: {
    description: 'filterOptions.isGift',
    defaultMessage: 'Order is a gift',
    id: 'KTXskU',
  },
  isNotGift: {
    description: 'filterOptions.isNotGift',
    defaultMessage: 'Order is not a gift',
    id: 'rJq4vu',
  },
});

export const PackingSlipMessages = defineMessages({
  printed: {
    description: 'filterOptions.labelPrinted',
    defaultMessage: 'Printed',
    id: 'CI9dYY',
  },
  notPrinted: {
    description: 'filterOptions.labelNotPrinted',
    defaultMessage: 'Not Printed',
    id: 'Iea+MZ',
  },
});

export const WarehouseStatusMessages = defineMessages({
  NoStatus: {
    description: 'filter No Status option for warehouse status column',
    defaultMessage: 'No Status',
    id: 'WrMt8h',
  },
  ReadyToPick: {
    description: 'filter ReadyToPick option for warehouse status column',
    defaultMessage: 'Ready To Pick',
    id: 'wNwq4Q',
  },
  Picking: {
    description: 'filter Picking option for warehouse status column',
    defaultMessage: 'Picking',
    id: '5o2vF3',
  },
  Picked: {
    description: 'filter Picked option for warehouse status column',
    defaultMessage: 'Picked',
    id: 'gWSUwD',
  },
});

export const PickingExceptionMessages = defineMessages({
  notEnoughStock: {
    description: 'Picking exception: Not enough stock',
    defaultMessage: 'Not enough stock',
    id: 'mGWj/S',
  },
  productDamaged: {
    description: 'Picking exception: Damaged Inventory',
    defaultMessage: 'Damaged Inventory',
    id: '6V2nL2',
  },
  productNotFound: {
    description: 'Picking exception: Product not at location',
    defaultMessage: 'Product not at location',
    id: '2PiZrq',
  },
  other: {
    description: 'Picking exception: Other',
    defaultMessage: 'Other',
    id: 'WRuPFb',
  },
});

export const PickListMessages = defineMessages({
  printed: {
    description: 'filter Printed option for pick list printed column',
    defaultMessage: 'Printed',
    id: '8UGxdG',
  },
  notPrinted: {
    description: 'filter Not Printed option for pick list printed column',
    defaultMessage: 'Not Printed',
    id: 'chyzsL',
  },
});

export const ResidentialOrCommericalMessages = defineMessages({
  residential: {
    description: 'filterOptions.residential',
    defaultMessage: 'Residential',
    id: 'TSYwqo',
  },
  commercial: {
    description: 'filterOptions.commercial',
    defaultMessage: 'Commercial',
    id: 'orLo0a',
  },
});

export const RateMessages = defineMessages({
  hasRate: {
    description: 'filterOptions.hasRate',
    defaultMessage: 'Has Rate',
    id: '0YLgI0',
  },
  doesNotHaveRate: {
    description: 'filterOptions.doesNotHaveRate',
    defaultMessage: 'Does Not Have Rate',
    id: 'G7xog8',
  },
});
